import { ToggleButton, ToggleButtonGroup } from "@mui/material"
import { useTenant } from "../../contexts/TenantContext"
import { tint } from "../../utils/textStyles"

export const BookingFilterValue = {
  ACTIVE: "active",
  ALL: "all",
}

// What is still ahead: the guest opens the profile for the next appointment, so this is the default.
const ACTIVE_STATUSES = ["BOOKED", "PENDING"]

export const filterBookings = (bookings, filter) =>
  filter === BookingFilterValue.ACTIVE
    ? bookings.filter((booking) => ACTIVE_STATUSES.includes(booking?.status))
    : bookings

/**
 * "Aktív" / "Összes" above the guest's bookings. Themed like the count pill beside the title, so
 * the two read as one row.
 */
const BookingFilter = ({ value, onChange }) => {
  const { displayConfig } = useTenant()
  const textColor = displayConfig?.color
  const accent = displayConfig?.primaryColor

  const buttonSx = {
    px: 2,
    py: 0.5,
    textTransform: "none",
    fontSize: 13,
    fontWeight: 700,
    color: tint(textColor, 0.65),
    "&:hover": { backgroundColor: tint(accent, 0.08) },
    "&.Mui-selected, &.Mui-selected:hover": {
      color: textColor,
      backgroundColor: tint(accent, 0.18),
    },
  }

  return (
    <ToggleButtonGroup
      exclusive
      size="small"
      value={value}
      // A click on the selected option answers null: the filter stays as it is.
      onChange={(_, next) => next && onChange(next)}
      aria-label="Foglalások szűrése"
      data-testid="profile-booking-filter"
      // Two separate pills rather than a joined bar: the group squares the inner corners and drops
      // the left border, which this undoes at the group's own level, where it takes precedence.
      sx={{
        gap: 1,
        "& .MuiToggleButtonGroup-grouped": {
          ml: 0,
          borderRadius: 999,
          border: `1px solid ${tint(accent, 0.35)}`,
        },
      }}
    >
      <ToggleButton value={BookingFilterValue.ACTIVE} data-filter="active" sx={buttonSx}>
        Aktív
      </ToggleButton>
      <ToggleButton value={BookingFilterValue.ALL} data-filter="all" sx={buttonSx}>
        Összes
      </ToggleButton>
    </ToggleButtonGroup>
  )
}

export default BookingFilter
